<template>

  <div class="container-fluid">

  <transition :css="false">
  <el-dialog
  title="Add Email Details"
  :visible.sync="emailShow"
  width="40%"
  top="20vh"
  center>
  <div>

    <form >
           <arnergy-input
              v-model="form.name"
              :error="formErrors.name"
              label="Email Address"
            />
             <arnergy-input
              v-model="form.description"
              :error="formErrors.description"
              label="Email To"
            />
             <arnergy-input
              v-model="form.description"
              :error="formErrors.description"
              label="Email CC"
            />
             <arnergy-input
              v-model="form.description"
              :error="formErrors.description"
              label="Email Bcc"
            />

             <div class="pt-4 text-right">
            <button class="btn btn-primary" >Submit</button>
        </div>
        </form>
  </div>

</el-dialog>
</transition>
<transition :css="false">
<el-dialog
  title="Add SMS Details"
  :visible.sync="smsShow"
  width="40%"
  top="20vh"
  center>
  <div>

    <form >
           <arnergy-input
              v-model="form.name"
              :error="formErrors.name"
              label="Phone Number"
            />



             <div class="pt-4 text-right">
            <button class="btn btn-primary" >Submit</button>
        </div>
        </form>
  </div>

</el-dialog>
</transition>



<transition :css="false">
<el-dialog
  title="Add Group"
  :visible.sync="centerDialogVisible2"
  width="40%"
  top="20vh"
  center>
  <div>

    <form >
           <arnergy-input
              v-model="form.name"
              :error="formErrors.name"
              label="Group Name"
            />
             <arnergy-input
              v-model="form.description"
              :error="formErrors.description"
              label="Group Description"
            />
            <div class="form-group form-check ml-3">
    <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="notificationShow">
    <label class="form-check-label" for="exampleCheck1">Allow Notification {{emailShow}} </label>
  </div>
   <div class="form-group form-check ml-3">
    <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="subgropShow">
    <label class="form-check-label" for="exampleCheck1">Enable Subgroup</label>
  </div>
   <div class="form-group form-check ml-3">
    <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="emailShow">
    <label class="form-check-label" for="exampleCheck1">Enable Email</label>
  </div>
    <div class="form-group form-check ml-3">
    <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="smsShow">
    <label class="form-check-label" for="exampleCheck1">Enable SMS</label>
  </div>

             <div class="pt-4 text-right">
            <button class="btn btn-primary" >Create Group</button>
        </div>
        </form>
  </div>

</el-dialog>
</transition>

    <transition :css="false">
    <el-dialog title="Are you sure" :visible.sync="centerDialogVisible" width="30%" center>
      <span>Do you want to delete this request?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">No</el-button>
        <el-button type="primary" @click="deleteRequest(selectedRequest.id)">Yes</el-button>
      </span>
    </el-dialog>
    </transition>
    <vk-offcanvas overlay flipped stuck :show.sync="showInvoice">
      <!-- {{packageConfigs}} -->
      <div>
        <vk-offcanvas-close @click="showInvoice = false"></vk-offcanvas-close>
        <!-- <h3>New Customer</h3> -->
        <hr />
        <svg
          class="wow-star"
          version="1.1"
          viewBox="0 0 300 300"
          preserveAspectRatio="xMinYMin meet"
        >
          <foreignobject class="wow-star__text" width="100%" height="100%" v-html="receiptData" />
        </svg>
        <!-- <div class="invoice-section" v-html="receiptData"></div> -->
        <!-- {{systemTypes}} -->
      </div>
    </vk-offcanvas>

      <div class="mt-5"   v-if="usertype == 'customer super admin' || usertype == 'customer admin'">
        <div class="">
          <el-tabs  v-model="activeTab">

              <can I="create" a="installation" >
              <el-tab-pane label="Customers" name="customers" >
                <div class="">
                  <Customers ></Customers>
                </div>
              </el-tab-pane>
            </can>
            <can I="create" a="installation" >
              <el-tab-pane label="Devices" name="groupitems" >
                <div class="d-flex justify-content-end">
                  <GroupItem ></GroupItem>
                </div>
              </el-tab-pane>
            </can>

          </el-tabs>


      </div>
    </div>


     <div class="mt-5"  v-if="usertype != 'customer super admin' && usertype !='customer admin'">
        <div class="">
          <el-tabs  v-model="activeTab">
           <can I="create" a="installation" >
              <el-tab-pane label="Group" name="manage_requestsdd" >
                  <Group></Group>
              </el-tab-pane>
            </can>
            <can I="create" a="installation" >
              <el-tab-pane label="Subgroup" name="subgroup" >
                <div class="">
                  <Subgroup ></Subgroup>
                </div>
              </el-tab-pane>
            </can>
              <can I="create" a="installation" >
              <el-tab-pane label="Customers" name="customers" >
                <div class="">
                  <Customers ></Customers>
                </div>
              </el-tab-pane>
            </can>
            <can I="create" a="installation" >
              <el-tab-pane label="Devices" name="groupitems" >
                <div class="d-flex justify-content-end">
                  <GroupItem ></GroupItem>
                </div>
              </el-tab-pane>
            </can>

          </el-tabs>


      </div>
    </div>




  </div>
</template>

<script>
/* eslint-disable */
// import ejs from "ejs";
import { mapGetters, mapActions } from "vuex";
import { readString } from "fs-web";
import templateLocation from "raw-loader!./templates/invoice.ejs";
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import Subgroup from '../user-mgt/Subgroup.vue'
import Group from '../user-mgt/Group.vue'
import GroupItem from '../user-mgt/GroupItem.vue'
import Customers from '../user-mgt/Customers.vue'
import ModalMain from '../kitchen/Onboarding/ModalMain.vue'
import ArnergyInput from '../kitchen/ArnergyInput.vue'
import { Dialog } from "element-ui";
const dataParam = {
  packageConfig: null,
  order: {
    paymentModel: "OS",
    orderVat: 5,
    orderDiscount: 0,
    typeOfBuilding: "Normal",
    roofType: "Aluminium",
    roofCondition: "Very Good",
    roofReadiness: "Very Ready",
    roofAge: 4,
    roofComment: "No comment here\tRoof is ready for installation",
    deviceTypeId: 3,
    comment: "No comment here\tRoof is ready for installation"
  },
  user: {
    firstName: "Test",
    email: "seun.omotunde@arnergy.com",
    roleType: "customer",
    lastName: "Testerson",
    dateOfBirth: "2019-07-10T17:22:47.521Z",
    phoneNumber: "234671993331",
    gender: 0,
    wallet: 0,
    createdAt: "2019-07-10T17:55:56.668Z",
    updatedAt: "2019-07-10T17:55:56.668Z",
    realm: "",
    username: "seun.omotunde@arnergy.com",
    emailVerified: null,
    id: 615,
    street_route: null,
    cpassword: "<%DUMMY%>",
    stateId: null,
    countryId: 1,
    lgaId: null,
    deviceRequest: {
      paymentModel: "OS",
      orderVat: 7.5,
      orderDiscount: 0,
      typeOfBuilding: "Normal",
      roofType: "Aluminium",
      roofCondition: "Very Good",
      roofReadiness: "Very Ready",
      roofAge: 4,
      roofComment: "No comment here\tRoof is ready for installation",
      deviceTypeId: 3,
      comment: "No comment here\tRoof is ready for installation"
    }
  },
  packageType: {
    name: "ARNERGY5000",
    description: "Arnergy5000 are the pet version for SME",
    price: 4004485,
    OTAEnabled: true,
    chainable: true,
    createdAt: "2018-06-21T20:20:25.000Z",
    updatedAt: "2018-06-21T20:20:25.000Z",
    id: 3,
    packageComponents: [
      {
        quantity: 1,
        createdAt: "2019-07-02T12:28:34.267Z",
        updatedAt: "2019-07-02T12:28:34.267Z",
        id: 12,
        deviceTypeId: 3,
        componentId: 2,
        componentTypeId: null,
        componentType: {
          name: "inverter",
          description: null,
          createdAt: "2018-06-21T20:20:25.000Z",
          updatedAt: "2018-06-21T20:20:25.000Z",
          id: 2
        }
      },
      {
        quantity: 2,
        createdAt: "2019-07-02T12:28:47.102Z",
        updatedAt: "2019-07-02T12:28:47.102Z",
        id: 13,
        deviceTypeId: 3,
        componentId: 1,
        componentTypeId: null,
        componentType: {
          name: "battery",
          description: null,
          createdAt: "2018-06-21T20:20:25.000Z",
          updatedAt: "2018-06-21T20:20:25.000Z",
          id: 1
        }
      },
      {
        quantity: 15,
        createdAt: "2019-07-02T14:16:33.398Z",
        updatedAt: "2019-07-02T14:16:33.398Z",
        id: 16,
        deviceTypeId: 3,
        componentId: 3,
        componentTypeId: null,
        componentType: {
          name: "solar panels",
          description: null,
          createdAt: "2018-06-21T20:20:25.000Z",
          updatedAt: "2018-06-21T20:20:25.000Z",
          id: 3
        }
      }
    ]
  },
  selectedRequest: null
};
export default {
  name: "manage-requests",
  data() {
    return {
      receiptData: "Loading...",
      centerDialogVisible: false,
      showInvoice: false,
       centerDialogVisible2: false,
      defPage:true,
      usertype: localStorage.roleType,
      secPage: false,
      showModal: false,
      activeTab :"manage_requestsdd",
      starting:true,
      form:{
        name: '',
        desc: ''
      },
      formErrors: {
        name: '',
        description: ''
      },
      notificationShow: false,
      emailShow: false,
      smsShow: false,
      subgropShow: false,
      lastPage:false,
      searchTerm: "",
      selectOption: {
        enabled: true
      },
      responseData: "",
      errors: "",
      componentName: "",
      columns: [
        {
          label: "Customer Name",
          field: "full_name"
        },
        {
          label: "Installation Name",
          field: "installation_name",
          filterable: true
        },
        {
          label: "Phone Number",
          field: "user.phone",
          filterable: true
        },
        // {
        //   label: 'Installation Address',
        //   field: 'address',
        //   filterable: true,
        // },
        {
          label: "Desired Bundle",
          field: "deviceType.name",
          filterable: true
        },
        {
          label: "System Capacity",
          field: "system.capacity",
          filterable: true
        },
        {
          label: "Actions",
          field: "actions"
        }
      ],
      deviceRequests: [],
      rows: []
    };
  },
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-dialog": Dialog,
    ModalMain,
    Customers,
    ArnergyInput,
    Group,
    GroupItem,
    Subgroup
  },
  methods: {
    random_num: dumm => {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal() {
      this.$refs.invoiceModal.show();
    },
    hideModal() {
      this.$refs.invoiceModal.hide();
    },
    sub(){
      console.log('tutu')
    },
    navTo(id) {
      this.$router.push({
        name: "addInstalation",
        params: {
          id: id
        }
      });
    },
    async fetchInvoice(rowData) {
      // console.log({ rowData, templateLocation });
      this.showInvoice = true;
      let { order, user, packageConfig, packageType } = dataParam;
      // readString(templateLocation).then(console.log);
      let html = ejs.render(templateLocation, {
        order,
        user,
        packageConfig,
        packageType,
        setupURL: false
      });
      const el = this.$refs.invoiceSection;
      const options = {
        type: "dataURL"
      };
      this.receiptData = html;
      // this.finalData = await this.$html2canvas(el, options);
      // console.log({ finalData });
    },

    showFirst(){
      this.defPage = false;
      this.lastPage = true;
      this.secPage = true;
    },

    addModal(){
      this.showModal = true;
    },



    deleteRequest(id) {
      const HTTP = this.$httpUtils.instance;
      // console.log(id);
      HTTP.delete(`/device_requests/${id}`)
        .then(response => {
          this.centerDialogVisible = false;
          window.location.reload(true);
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  computed: {},
  mounted() {
    if (!this.$can("create", "installation")) {
      this.$router.push({
        path: "/"
      });
      return;
    }
    const HTTP = this.$httpUtils.instance;
    const container = this;

    // {"status": 1}
    HTTP.get(
      `/device_requests/?filter={"include": ["user","transactionHistories", {"deviceType": { "packageComponents": "componentType" }}],
      "where": {
        "or":[
          {"status": 0},
          {"status": 1}
        ]
        } }`,
      {}
    ).then(response => {
      // console.log(JSON.stringify(rolesdata.data))
      // console.log({ response });

      container.deviceRequests = response.data.filter(x => x.user);
    });
  }
};
</script>

<style>
.widget_box {
  min-height: auto !important;
}

.modal-header {
  border-bottom-left-radius: 50% 20%;
  border-bottom-right-radius: 50% 20%;
  background: #ecf2f6;
  /* height: 100px; */
}
</style>



// WEBPACK FOOTER //
// src/components/pages/devices/ManageRequestsuser.vue